import axios from "axios";

let mockingEnabled = false;

const mocks = {};

export function addMock(url, data) {
  mocks[url] = data;
}

export function enableMocking(state) {
  mockingEnabled = state;
  if (mockingEnabled && process.env.NODE_ENV === "development") {
    addMock("/default/developer", {
      data: {
        created_at: 1634236073,
        id: "73d932a4-ba8e-45c6-9a59-cb8429832f6c",
        status: 0,
        email: "site@upgraded.com",
        custom_id: "site@upgraded.com",
        updated_at: 1647286152,
        roles: [],
        consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
        meta: '{"full_name": "site@upgraded.com", "migrated": "false", "legacy": "site", "sids": "112,1512288,1512290,1512308,1512309,1512371,1512401,1512709,1602404,1602889,1603307,1603321,1603457,1604528,1604823,1605529,1605574,1605922,1609855,1610092,1610470,1610621,1611184,1611199,1611239,1611268,1611616,1611715,1611748,1611940,1611943,1612036,1612361,1612393,1612396,1612453,1612480,1612483,1612651,1612657,1613058,1613132,1613320,1613698,1613854,1613910,1613915,1613916,1614026,1614145,1614357,1614411,1614412,1614416,1614429,1614842,1614997,1615065,1616028,1616173,1616831,1616859,1616862,1616898,1616974,1616976,1616979,1616980,1616981,1616984,1616988,1617023,1617212,1617839,1618977,1619090,1619150,1619615,1619687,1619690,1619692,1620006,1620017,1620161,1620245,1620248,1620505,1620514,1620516,1620616,1621083,1621098,1621099,1621101,1621102,1621103,1621104,1621105,1621176,1621218,1621335,1621406,1621648,1621665,1621709,1621735,1621748,1622117,1622599,1622600,1622672,1623320,1623874,1634040,1634311,1666381,1710237,1710238,1710239,1710245,1710246,1710247,1711108,1711109,1715233,1715234,1717682,1717689,1726535,1740300,1741782,1768567"}',
      },
    });

    addMock("/migrate", {
      data: [
        {
          name: "Foo Test",
          client_id: "3CUeVFTNMy0Ab77fHRDf_HBGZF8a",
          client_secret: "xiEzXsR8CRhWzBXvl2rieKr4WI4a",
          redirect_uris: "",
          username: "ProdPVUS-01",
        },
        {
          name: "Bar Test",
          client_id: "zRr0R86VkJutz0VmigPWZCBCf8Ua",
          client_secret: "PnFvrKvDcsg0GqbDEs_QOkdHKWga",
          redirect_uris: "",
          username: "ProdPVUS-01",
        },
        {
          name: "Zoo Test",
          client_id: "HtfuSNJFxJIW1CBch9ccLs5oHtUa",
          client_secret: "tQlfyVkxZasBR9f5HUsMYAvEitwa",
          redirect_uris: "",
          username: "ProdPVUS-01",
        },
      ],
    });

    addMock("/default/credentials/oauth2", {
      next: null,
      data: {
        data: [
          {
            created_at: 1645635579,
            id: "00e02c31-6ce3-4668-94d6-a599b276e7a4",
            tags: null,
            name: "ereredfdsfzdfeeef1111",
            client_secret: "COSe0sB1uDt1FA6uRiVkFck71X0Tkhgt",
            client_id: "PmBXgdMtu6WBNzEO70kehOVLBYqTnVvT",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645788851,
            id: "052fc088-f283-45e4-9e4a-2c29bcc006c1",
            tags: null,
            name: "test_2",
            client_secret: "CCqQ38u9X4Lj1AMCdsPhlORGXN0PoKQU",
            client_id: "94Y5NQojVEvPtQqSEOJJIKDNwmoMlb7g",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645635493,
            id: "12d40d1a-5edb-467e-b11e-d6209fd75b8a",
            tags: null,
            name: "rreeeee",
            client_secret: "kxftty745nAsht3Xqzxq7C1lR8EwBluW",
            client_id: "bnlpc4mStfGjSkO8IeF7gDY1kTEYZZut",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645633586,
            id: "1605d5f8-6acf-4bbd-96cc-9408aa66edc5",
            tags: null,
            name: "ssfsdfsf",
            client_secret: "lLWBNDYJ7xTHbu6Gv7qGlngWews7asq6",
            client_id: "OHxROVbcY0MiaezsCsSzWCpYxmRPElYb",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1641878027,
            id: "1b1694a3-abcd-4c87-9e1d-d4c3b4a80543",
            tags: null,
            name: "Foo Test",
            client_secret: "j2hIeH1WMCpLsN6J4dAWXw7RFV0a",
            client_id: "qVP__kqwvWCw0uaCYTBGUpJQiRsa",
            redirect_uris: ["https://legacy"],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1646068863,
            id: "1b200038-82c2-4f87-83a0-ebf6f7b98068",
            tags: null,
            name: "Bar Test",
            client_secret: "QwRt6bJQWFB6JF5aCEsB2AHxUAIxNfPK",
            client_id: "oUbWJ5zoCq0wsgmtXG5Oj9h04GuRl73H",
            redirect_uris: ["https://legacy"],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1638359073,
            id: "1be1aab5-3ae0-4a07-accb-b72bb6769d2c",
            tags: null,
            name: "Zoo Test",
            client_secret: "1UqNZ4PbGTxf2jBfvNORNrhHgZ2RD6zE",
            client_id: "xwbckG1rGctJzqdc6vynIq3nm7UW2A2Q",
            redirect_uris: ["https://legacy"],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1644844966,
            id: "1d3e3fbd-f80b-4203-8960-8e7906e92a00",
            tags: null,
            name: "efdsrtfdgd",
            client_secret: "186Ykd3qwA4F1kTqOXFR08n58QZNghAs",
            client_id: "TfrRjnKAGaEpLtDT5YiQn183Uz42MAiR",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645639154,
            id: "22efdd35-b38a-4493-87c2-79b2c4d9a4f7",
            tags: null,
            name: "sdafdf",
            client_secret: "pTBkGLky6fk6UcmYxEJG7Rq2Gcsj5BdP",
            client_id: "3ZKOMZOL6yp6SNR5xSBFJOndSIoVopnf",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1644273390,
            id: "23020c44-a24e-4ed1-9160-e83556b0f037",
            tags: null,
            name: "Becky",
            client_secret: "nFietETp6UsnnKAxCCNzZ2eLB8CMGvoW",
            client_id: "yKgqAruRYfEu7KiSX3NX6LyzsYvyc0JM",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645634655,
            id: "24c5de7f-2767-40b4-b9e6-111c7dff7afc",
            tags: null,
            name: "cdfdf",
            client_secret: "IQoBoTLVolfItymdgrn3qAzff1UvTrhV",
            client_id: "IdUvNwUZlHHp7187Gl0eR1o8k4VHDqNl",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1645634543,
            id: "2d375556-9706-4b3e-8574-4a28e44722db",
            tags: null,
            name: "jghg",
            client_secret: "fyvL23rf5imSAF8nO3k2J1GyciCcKyLE",
            client_id: "ZZcfVee1H28hMuQD6XmNXN1xmQTr9s8S",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
          {
            created_at: 1634236666,
            id: "340211de-74f6-43da-8510-cc499403182a",
            tags: null,
            name: "VovasAppd",
            client_secret: "47wt5a18OL3My3BUmV5qWcfA5wUxgv4x",
            client_id: "tVOY5AsowvHbeBsHuQbOGeDTmE3ub6my",
            redirect_uris: [
              "https://developers.rakutenadvertising.com/default-callback",
            ],
            hash_secret: false,
            client_type: "confidential",
            consumer: { id: "b66c5328-9f5e-4b71-b634-c54d5fb7aa35" },
          },
        ],
      },
    });

    const instance = axios.create();
    instance.interceptors.request.use((config) => {
      config.foo = 456;
    });
  }
}

const isUrlMocked = (url) => url in mocks;

const getMockError = (config) => {
  const mockError = new Error();
  mockError.mockData = mocks[config.url];
  mockError.config = config;
  return Promise.reject(mockError);
};

const isMockError = (error) => Boolean(error.mockData);

const getMockResponse = (mockError) => {
  const { mockData, config } = mockError;
  // Handle mocked error (any non-2xx status code)
  if (mockData.status && String(mockData.status)[0] !== "2") {
    const err = new Error(mockData.message || "mock error");
    err.code = mockData.status;
    return Promise.reject(err);
  }
  // Handle mocked success
  return Promise.resolve(
    Object.assign(
      {
        data: {},
        status: 200,
        statusText: "OK",
        headers: {},
        config,
        isMock: true,
      },
      mockData
    )
  );
};

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    if (mockingEnabled && isUrlMocked(config.url)) {
      console.log("axios mocking " + config.url);
      return getMockError(config);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isMockError(error)) {
      return getMockResponse(error);
    }
    return Promise.reject(error);
  }
);
